var _defs, _path, _polygon, _path2, _polyline, _path3, _path4, _path5, _path6, _path7, _polyline2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReference(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.73,238A15.27,15.27,0,0,1,45.5,222.77V67.9L102,18h93.26A15.27,15.27,0,0,1,210.5,33.23V222.77A15.23,15.23,0,0,1,195.27,238Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.01 18 101.77 67.82 45.5 67.9 102.01 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.31,107.12h28.4a8.55,8.55,0,0,1,8.53,8.52v19.55"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "143.63 126.08 153.25 135.65 162.86 126.08"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.15,149v-8.24c0-7.2-5.79-9.86-12.5-9.86L99,140l-8.24-9.07c-6.7,0-11.91,2.66-11.91,9.86V149Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.32,113.41a9.32,9.32,0,1,1-18.63,0V109.9a9.32,9.32,0,1,1,18.63,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.39,193.94V185.7c0-7.2-5.79-9.85-12.49-9.85l-7.65,9.07L145,175.85c-6.71,0-11.91,2.65-11.91,9.85v8.24Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.57,158.36a9.32,9.32,0,1,1-18.64,0v-3.5a9.32,9.32,0,1,1,18.64,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.16,185.84H107.5A8.54,8.54,0,0,1,99,177.32V155.83"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "108.59 164.94 98.97 155.38 89.36 164.94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReference);
export default __webpack_public_path__ + "static/media/reference.73e2a6f1b2fd8b701b5e8099a54574d9.svg";
export { ForwardRef as ReactComponent };